<script setup lang="ts">
import { computed } from "vue";
import { fullImageViewState } from "../states/fullImgView";

const isShow = computed(() => {
  return !!fullImageViewState.value;
});
const close = () => {
  fullImageViewState.value = "";
};
const clickArea = (e: MouseEvent) => {
  const el = e.target as HTMLElement;
  if (el.tagName !== "IMG") {
    close();
  }
};
</script>
<template>
  <div v-if="isShow" class="full-img-view" @click="clickArea">
    <svg
      @click="close"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 6L18 18M6 18L18 6" stroke="#A4A4A4" stroke-width="1.5" />
    </svg>
    <div class="img-wrapper">
      <img :src="fullImageViewState" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.full-img-view {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(30, 24, 24, 0.96);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.full-img-view svg {
  position: absolute;
  top: 16px;
  right: 12px;
  cursor: pointer;
}

.full-img-view .img-wrapper {
  width: 90%;
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.full-img-view .img-wrapper img {
  object-fit: contain;
  max-height: 100%;
  max-width: 100%;
}
</style>
